module.exports = __webpack_public_path__ + "d3ddea6c4cad93d9da0440380b705f29.otf";